export enum MultiSetsPromotionStates {
    INIT = 'init',
    BASIC = 'basic',
    RESTORE = 'restore',
    START = 'start',
    IN_PROGRESS = 'inProgress',
    END = 'end',
    DISABLED = 'disabled'
}
